import axios from 'axios'
import queryString from 'query-string'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { PeopleContactsResponse } from 'src/models/people.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'
import { BackendErrorPayload } from 'src/utils/error.utils'

export const GET_USER_CONNECTIONS_INIT = 'app/people/GET_USER_CONNECTIONS_INIT'
export const GET_USER_CONNECTIONS_SUCCESS =
  'app/people/GET_USER_CONNECTIONS_SUCCESS'
export const GET_USER_CONNECTIONS_FAILURE =
  'app/people/GET_USER_CONNECTIONS_FAILURE'

export type GetUserConnectionsFailurePayload = BackendErrorPayload<string>

export interface GetUserConnectionsQueryParams {
  perPage?: number
  page?: number
  sort?: string
  count?: number
  verified?: boolean
  search?: string
  showDeactivatedUsers?: boolean
  organizationRoles?: string[]
  renderMetrics?: boolean
}

export interface GetUserConnectionsInitPayload {
  queryParams: GetUserConnectionsQueryParams
}

export type GetUserConnectionsSuccessPayload = PeopleContactsResponse

export interface GetUserConnectionsInitAction {
  type: typeof GET_USER_CONNECTIONS_INIT
}
export interface GetUserConnectionsSuccessAction {
  type: typeof GET_USER_CONNECTIONS_SUCCESS
  payload: GetUserConnectionsSuccessPayload
}
export interface GetUserConnectionsFailureAction {
  type: typeof GET_USER_CONNECTIONS_FAILURE
  payload: GetUserConnectionsFailurePayload
}

export type GetUserConnectionsActions =
  | GetUserConnectionsInitAction
  | GetUserConnectionsSuccessAction
  | GetUserConnectionsFailureAction

const createGetUserConnectionsInitAction =
  (): GetUserConnectionsInitAction => ({
    type: GET_USER_CONNECTIONS_INIT,
  })
const createGetUserConnectionsSuccessAction = (
  payload: GetUserConnectionsSuccessPayload,
): GetUserConnectionsSuccessAction => ({
  type: GET_USER_CONNECTIONS_SUCCESS,
  payload,
})
const createGetUserConnectionsFailureAction = (
  payload: GetUserConnectionsFailurePayload,
): GetUserConnectionsFailureAction => ({
  type: GET_USER_CONNECTIONS_FAILURE,
  payload,
})

export const getUserConnections = (
  queryParameters?: GetUserConnectionsQueryParams,
): ThunkAction<
  Promise<GetUserConnectionsFailureAction | GetUserConnectionsSuccessAction>,
  RootState,
  void,
  GetUserConnectionsActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetUserConnectionsActions>,
    getState: () => RootState,
  ): Promise<
    GetUserConnectionsFailureAction | GetUserConnectionsSuccessAction
  > => {
    dispatch(createGetUserConnectionsInitAction())
    return axios
      .get<GetUserConnectionsSuccessPayload>(
        `/connections?${queryParameters ? queryString.stringify(queryParameters) : ''}`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        async (response) => {
          return dispatch(createGetUserConnectionsSuccessAction(response.data))
        },
        (err) => {
          return dispatch(
            createGetUserConnectionsFailureAction(err.response.data),
          )
        },
      )
  }
}
